const imageUtil = require('../image/imageUtil');

module.exports.color = "#05149E";
module.exports.logoImageUrl = `${imageUtil.getBackOfficeImgixBaseUrl()}/resellers/flipdish/logo.main`;